import { Link } from "react-router-dom";
import { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import Logo from "./Logo";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setSending(true);
    try {
      await api.post("/newsletter", { email, consent: true });
      toast.success("Subscribed. Thank you!");
      setEmail("");
    } catch (err) {
      toast.error("Could not subscribe. Try again.");
    }
    setSending(false);
  };

  return (
    <footer data-testid="site-footer" className="bg-slate-900 text-slate-300 mt-24">
      <div className="hc-container py-16 grid md:grid-cols-2 lg:grid-cols-5 gap-10">
        <div className="lg:col-span-2">
          <Logo variant="full" tone="light" size={44} className="mb-4" testId="footer-logo" />
          <p className="text-slate-400 leading-relaxed text-[15px] max-w-md">
            India's Cochlear Implant Knowledge, Access & Rehabilitation Platform.
            From diagnosis to surgery guidance to lifelong rehabilitation support —
            everything families need to know about cochlear implants in India.
          </p>

          <form onSubmit={subscribe} className="mt-6 flex gap-2 max-w-md">
            <input
              data-testid="footer-newsletter-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your email for hearing-health updates"
              className="flex-1 bg-slate-800 border border-slate-700 rounded-lg px-3 py-2.5 text-sm text-white placeholder-slate-500 focus:outline-none focus:border-sky-500"
            />
            <button
              data-testid="footer-newsletter-submit"
              disabled={sending}
              className="bg-sky-600 hover:bg-sky-500 text-white px-4 py-2.5 rounded-lg text-sm font-medium"
            >
              {sending ? "..." : "Subscribe"}
            </button>
          </form>
        </div>

        <div>
          <h4 className="font-serif text-white text-base mb-4 font-semibold">Knowledge</h4>
          <ul className="space-y-2.5 text-[14px]">
            <li><Link to="/about-cochlear-implants" className="hover:text-white">About Cochlear Implants</Link></li>
            <li><Link to="/child-cochlear-implant" className="hover:text-white">For Children</Link></li>
            <li><Link to="/adult-cochlear-implant" className="hover:text-white">For Adults</Link></li>
            <li><Link to="/rehabilitation" className="hover:text-white">Rehabilitation</Link></li>
            <li><Link to="/knowledge-centre" className="hover:text-white">Knowledge Centre</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-serif text-white text-base mb-4 font-semibold">Access</h4>
          <ul className="space-y-2.5 text-[14px]">
            <li><Link to="/cochlear-implant-eligibility" className="hover:text-white">Check Eligibility</Link></li>
            <li><Link to="/cochlear-implant-cost-funding" className="hover:text-white">Cost & Funding</Link></li>
            <li><Link to="/doctors" className="hover:text-white">Meet Dr. Sanjay Sachdeva</Link></li>
            <li><Link to="/csr" className="hover:text-white">CSR Partnerships</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-serif text-white text-base mb-4 font-semibold">Connect</h4>
          <ul className="space-y-2.5 text-[14px]">
            <li><Link to="/technology" className="hover:text-white">Technology & Products</Link></li>
            <li><Link to="/patient-stories" className="hover:text-white">Patient Stories</Link></li>
            <li><Link to="/news" className="hover:text-white">News & Research</Link></li>
            <li><Link to="/register" className="hover:text-white">Register / Get Help</Link></li>
            <li><a href="/admin/login" className="hover:text-white">Admin Login</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-800">
        <div className="hc-container py-6 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-[13px] text-slate-500">
          <div>
            © {new Date().getFullYear()} CochlearImplantSurgery.in — Powered by HearClear. All rights reserved.
          </div>
          <div className="flex flex-wrap gap-x-5 gap-y-2">
            <Link to="/privacy" className="hover:text-slate-300">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-slate-300">Terms</Link>
            <Link to="/medical-disclaimer" className="hover:text-slate-300">Medical Disclaimer</Link>
          </div>
        </div>
        <div className="hc-container pb-6 text-[12px] text-slate-500 leading-relaxed">
          <p>
            <strong className="text-slate-400">Medical disclaimer:</strong> Information on this site is for awareness and
            education only and does not replace consultation with a qualified ENT surgeon, audiologist or medical professional.
            Cochlear implant eligibility must be determined after clinical evaluation and diagnostic testing. Product names,
            images and content shown in the Technology section are owned by their respective manufacturers (Cochlear Limited,
            MED-EL, Advanced Bionics) and are used here for informational purposes; please visit official manufacturer sites
            for complete product information.
          </p>
        </div>
      </div>
    </footer>
  );
}
